export enum ErrorCode {
  // Api
  AuthSsoError = 'B4300',
  AuthRejectedBlackListError = 'B4303',
  AuthRejectedWhiteListError = 'B4304',
  ProjectConfigNotFoundError = 'B4323',
  UserNotificationsToggleError = 'B4310',
  UserIsOpenedAllItemsToggleError = 'B4324',
  UserOnboardingFinishError = 'B4311',
  UserItemBonusOpenError = 'B4317',
  UserCheckIfBonusIsAvailableError = 'B4318',
  UserBuyBonusError = 'B4320',
  UserCheckIfItemIsAvailableError = 'B4313',
  UserNotEnoughEnergyError = 'B4314',
  UserItemIsUnavailableError = 'B4315',
  UserItemOpenError = 'B4316',
  NewUserRegistrationError = 'B4325',
  NewUserAuthorizationError = 'B4326',
  ProjectStageNotAllowActionError = 'B4327',
  SSOTokenNotActive = 'B4100',
  CampaignNameAlreadyExist = 'B4111',
  InvalidAge = 'B4102',
  AuthProjectTokenError = 'B4301',
  InvalidCitizenship = 'B4103',
  InvalidUserInfoError = 'B4109',
  CampaignDoesNotExistError = 'B4110',
  UserBanned = 'B4444',
  SiebelIdIsNotDefined = 'B4104',
  UserIsNotDefinedError = 'B4302',
  UserFetchStatisticsError = 'B4312',
  UserIsNotClient = 'B4307',
  ProductLoyalties = 'B5103',
  UnauthorizedError = 'B4001',
  BadRequest = 'B4002',
  HeaderValidation = 'B4003',
  NotFound = 'B4004',
  RequestValidation = 'B4005',
  InternalServer = 'B5001',
  QueryFailed = 'B5002',
  PersonalInfoError = 'B5012',
  BundleAllRequestError = 'B5025',
  ActivePrimaryDetailRequestError = 'B5026',
  GetUserIdEmptyPayload = 'B4010',
  GetPortalUserId = 'B5010',
  SsoTokenIntrospect = 'B5020',
  SsoUserInfo = 'B5021',
  GetProductLoyaltiesV2 = 'B5022',
  // Client
  TestError = 'F9999',
  MbUserGuestError = 'F2001',
  UnmatchedError = 'F2002',
  BoundaryError = 'F2003',
  ShareError = 'F2004',
  RetrieveStatisticError = 'F2005',
  LoadFontsError = 'F2006',
  CacheError = 'F2007',
  LoadAssetsError = 'F2008',
  // ошибка без errorCode
  UndefinedError = 'F2009',
  // Неизвестная ошибка
  UnknownError = 'U0001',
}

// TODO: https://jira.tcsbank.ru/browse/SP-18532
export enum ErrorAction {
  LogoutWithReload = 'LogoutWithReload',
  Logout = 'Logout',
  Reload = 'Reload',
  ReopenItem = 'ReopenItem',
  ReopenBonus = 'ReopenBonus',
}

export const ERROR_BOUNDARY_MESSAGE = 'Something went wrong in app';

export const FAILED_TO_LOAD_FONTS_MESSAGE = 'Failed to load fonts';

export const FAILED_TO_LOAD_ASSETS_MESSAGE = 'Failed to load assets';

export const LOAD_ITEMS_ASSETS_ERROR = 'LOAD_ITEMS_ASSETS_ERROR';

export const FAILED_TO_SHARE_DATA_MESSAGE = 'Failed to share data';

export const FAILED_TO_COPY_DATA_MESSAGE = 'Failed to copy data';

export const FAILED_TO_FIND_CONFIG_FOR_ITEM_MESSAGE = 'Failed to find config for item';

export const FAILED_TO_FIND_CONTENT_CONFIG_FOR_STATISTIC_MESSAGE = 'Failed to find content config for statistic item';

export const FAILED_TO_FIND_VALIDATION_RULES_FOR_STATISTIC_MESSAGE =
  'Failed to find validation rules for statistic item';

export const FAILED_TO_PARSE_PLURAL_NUMBER_VALUE_MESSAGE = 'Failed to parse plural number value';

export const INVALID_STRING_VALUE_MESSAGE = 'String value is invalid';

export const LONG_STRING_VALUE_MESSAGE = 'String value is too long';

export const SHORT_STRING_VALUE_MESSAGE = 'String value is too short';

export const LOWERCASE_LETTERS_IN_STRING_VALUE_MESSAGE = 'String value has letters in lower case';

export const BLACK_LIST_STRING_VALUE_MESSAGE = 'String value is in blacklist';

export const WHITE_LIST_NUMBER_VALUE_MESSAGE = 'Number value is not in whitelist';

export const FAILED_TO_PARSE_NUMBER_VALUE_MESSAGE = 'Failed to parse number value';

export const FAILED_TO_PARSE_DATE_VALUE_MESSAGE = 'Failed to parse date value';

export const NEGATIVE_NUMBER_VALIDATION_ERROR_MESSAGE = 'Number value is negative';

export const LESS_THAN_NUMBER_VALIDATION_ERROR_MESSAGE = 'Number value is less than threshold';

export const MORE_THAN_NUMBER_VALIDATION_ERROR_MESSAGE = 'Number value is more than threshold';

export const NOT_INTEGER_NUMBER_VALIDATION_ERROR_MESSAGE = 'Number value is not integer';

export const MANY_SIGNS_AFTER_COMMA_IN_NUMBER_VALIDATION_ERROR_MESSAGE = 'Number has many signs after comma';
